// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"styles_mainContent__2_Jrc","openCat":"styles_openCat__2TtKJ"};